import useDevice from "../hooks/useDevice";
import Button from "./Button";
import Text from "./Text";


type ModalButtonType = "insert" | "update" | "delete" | "cancel" | "info" | "success" | "warning" | "error" | "default";
type ModalButtonProps = {
    type: ModalButtonType;
    onClick: () => void;
    text?: string;
    variant?: "primary" | "black" | "white" | "gray" | "regist" | "destructive";
    icon?: React.ReactNode;
};

function ModalButton({ type, onClick, text, variant, icon }: ModalButtonProps) {
    const device = useDevice();
    const isMobile = device !== 'desktop'

    const commonProps = {
        width: 50,
        height: 30,
        borderRadius: 8,
        style: { fontSize: "17px", fontWeight: "500", minWidth: "85px" }
    };

    switch (type) {
        case "insert":
            return (
                <Button fullWidth={isMobile} variant={"insert"} border={1} borderColor="#F3A24A" onClick={onClick} {...commonProps} >
                    <Text variant="span" size={14} weight={"bold"} color="#F3A24A">등록</Text>
                </Button>
            );

        case "update":
            return (
                <Button fullWidth={isMobile}  variant={"update"} onClick={onClick} {...commonProps} >
                    <Text variant="span" size={14} weight={"bold"} color="#3E63ED">수정</Text>
                </Button>
            );

        case "delete":
            return (
                <Button fullWidth={isMobile}  variant={"delete"} onClick={onClick} {...commonProps} >
                    <Text variant="span" size={14} weight={"bold"} color="#F14250">삭제</Text>
                </Button>
            );

        case "cancel":
            return (
                <Button fullWidth={isMobile} variant={"white"} onClick={onClick} {...commonProps} >
                    <Text variant="span" size={14} weight={"bold"} color="#555555">{text ?? "닫기"}</Text>
                </Button>
            );

        case "info" :
            return (
                <Button icon={icon} fullWidth={isMobile} variant={variant ? variant : "white"} onClick={onClick} {...commonProps} >
                    <Text variant="span" size={14} >{text}</Text>
                </Button>
            );

        case "warning" :
            return (
                <Button icon={icon} fullWidth={isMobile} role={"Y"} variant={"primary"} onClick={onClick} {...commonProps} >
                    <Text variant="span" size={14} >{text}</Text>
                </Button>
            );

        case "error" :
            return (
                <Button icon={icon} fullWidth={isMobile} role={"Y"} variant={"primary"} onClick={onClick} {...commonProps} >
                    <Text variant="span" size={14} >{text}</Text>
                </Button>
            );

        default:
            return (
                <Button
                    icon={icon}
                    fullWidth={isMobile}
                    variant={variant ?? "white"}
                    onClick={onClick}
                    style={{
                        width: "auto",
                        minWidth: "auto",
                        padding: "6px 15px",
                        display: "inline-flex",
                        alignItems: "center",
                    }}
                >
                    <Text variant="span" size={14}>{text}</Text>
                </Button>
            );
    }
}


export default ModalButton;
